export default {
    AddTag: "Добавить метку",
    DYWTDTTT: "Удалить этот тип метки?",
    ModifyTag: "Изменить метку",
    TNCBE: "Название метки не может быть пустым",

    completeStandardID: "Введите полный государственный ID",
    NationalStandardID: "Государственный ID",
    VersionName: "Название версии",
    UpgradeRequired: "Требуется ли обновление",
    UpgradeResult: "Результат обновления",
    UpgradeList: "Список ожидающих обновления",
    UpgradeDevices: "Обновить выбранные устройства",
    UpgradeLogs: "Журнал обновлений",
    UpgradeOrders: "Заявки на обновление",
    Upgrade: "Обновить",
    addDeviceFirst: "Сначала добавьте устройство",
    selectupgrade: "Выберите устройства для обновления!",
    cannotEmptyDevice: "Код устройства не может быть пустым",
    CurrentVersion: "Текущая версия",
    PendingUpgradeList: "Список ожидающих обновления",
    isAddUpgradeList: "Добавить в список обновления?",
    AddUpgradeList: "Добавить в список обновления",
    NotUpgrade: "Не обновлять",
    PendingUpgrade: "Ожидает обновления",
    UpgradeFailed: "Обновление не удалось",
    emptyChipId: "ChipId не может быть пустым",
    emptyModelId: "ID модели не может быть пустым",
    emptyVersionId: "ID версии не может быть пустым",
    enterVersionName: "Введите название версии",
    enterChipId: "Введите ChipId",
    uNotC: "Список обновления пуст!",
    deleteVersion: "Удалить версию?",
    upgradeState: "Состояние обновления",
    upgradeDate: "Дата обновления",
    getDataFial: "Не удалось получить данные",
    MD5Name: "Введите имя MD5",
    enterPartition: "Введите название раздела",
    selectModel: "Выберите название модели",
    emptyAttachment: "Вложение не может быть пустым",
    VersionID: "ID версии",
    Partition: "Раздел",
    emptyVersion: "Название версии не может быть пустым",
    emptyMD5: "MD5 не может быть пустым",
    searchAll: "Найти всё",
    playBack: "Список воспроизведения",
    upCamera: "Обновить камеру",
    initDevice: "Будет выполнена инициализация всех указанных устройств. Продолжить?",
    upCameras: "Обновить устройства из списка. Продолжить?",
}
